<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.xxzj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">Planetary Rolling Mill</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
        >The three-roller planetary rolling mill provided by our company has reached the contemporary international advanced level, and is an ideal equipment for tube and bar processing. It can be used for cold-rolled copper, hot-rolled brass and ferrous metal. The planetary rolling method can achieve more than</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">90%</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">of the section deformation in one pass. For example, the three-roller planetary rolling mill can achieve a deformation coefficient of more than</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">15</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">during continuous casting of copper tubes, and the casting structure can be substantially changed.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
      </p>
      <p>
        <strong>
          <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">Equipment composition：</span>
        </strong>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
            <br>
          </span>
        </b>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
        >This unit consists of a feeding system, a three-roller planetary tube mill, a discharge system, etc., and is equipped with corresponding electrical control, hydraulic, lubrication, cooling and pneumatic systems.</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        xxzj: require("../../../assets/img/common/xxzj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/xxzj.vue